import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import routes from './routes';
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import Toaster from 'v-toaster';
import VueTelInput from 'vue-tel-input';
import 'v-toaster/dist/v-toaster.css';
import * as Sentry from '@sentry/vue';
import {Integrations} from '@sentry/tracing';

Vue.use(VueGoodTablePlugin);
Vue.use(Vuelidate);
Vue.use(VueRouter);
Vue.use(VueTelInput);
Vue.use(Toaster, { timeout: 5000 });
const router = new VueRouter({ routes });
Sentry.init({
  Vue,
  dsn: 'https://c0b382882da842de8b38f7f3ffe35e6e@o576007.ingest.sentry.io/5729379',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});
new Vue({
  el: '#register-easycmt',
  router,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js